import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

// Replace this with your own config details
const config = {
  apiKey: 'AIzaSyBu3-fYwYUwkA40uZ4iB7S8ZukAK7Vu6kk',
  authDomain: 'ex-pense.firebaseapp.com',
  databaseURL: 'https://ex-pense.firebaseio.com',
  projectId: 'ex-pense',
  storageBucket: 'ex-pense.appspot.com',
  messagingSenderId: '774662061107',
  appId: '1:774662061107:web:3af8b02f384b0ed8d33746',
  measurementId: 'G-HZFPWE6Y0K'
};

// Initialize Firebase
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;
const storage = firebase.storage().ref();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
db.settings({});
db.enablePersistence();
// firebase collections
const users = db.collection('users');
const categories = db.collection('categories');

export default {
  db,
  auth,
  storage,
  currentUser,
  users,
  categories
};
